import * as React from "react";
import { Context } from "./_context";
export const ControlIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.75 14h-1.5v-1.75H1v-1.5h7.25V9h1.5v5ZM15 12.25h-3.5v-1.5H15v1.5ZM6.75 7h-1.5V5.25H1v-1.5h4.25V2h1.5v5ZM15 5.25H8.5v-1.5H15v1.5Z", fill: "currentColor" }));
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 16h3v2h-3v3h-2v-8h2v3Zm-4 2H2v-2h13v2ZM11 6h11v2H11v3H9V3h2v3ZM7 8H2V6h5v2Z", fill: "currentColor" }));
  return iconset[size];
};
ControlIcon.iconId = "9Xcg2d";
